import {
  MultisiteTableIcon,
  PermissionsIcon,
  TrendsIcon,
} from "../../../SolarGikLib/icons/common/navigation/NavIcons";
import { MultiSiteNavConfig } from "../../navigation/NavigationDrawer/NavigationDrawerModels";
import { UserAccessType } from "../../user/Models";

export const NavItemsConfig: MultiSiteNavConfig[] = [
  {
    pageName: "Multisite",
    pagePath: "/Multisite",
    icon: MultisiteTableIcon,
    visibilityFilter: ({ userAccessType }) => userAccessType >= UserAccessType.ViewDashboard,
  },
  {
    pageName: "Trends",
    pagePath: "/Trends",
    icon: TrendsIcon,
    visibilityFilter: ({ userAccessType }) => userAccessType >= UserAccessType.Viewer,
  },
  {
    pageName: "Permissions",
    pagePath: "/Permissions",
    icon: PermissionsIcon,
    visibilityFilter: ({ userAccessType }) => userAccessType >= UserAccessType.Admin,
  },
];
